import api from './api';

export const artistApi = {
  // 슬러그로 아티스트 상세 조회 (sourceId/sourceType은 slug가 DB에 없을 때 폴백용)
  getArtistBySlug: async (slug, { sourceId, sourceType } = {}, config = {}) => {
    const query = new URLSearchParams();
    if (sourceId) query.set('sourceId', sourceId);
    if (sourceType) query.set('sourceType', sourceType.toLowerCase());
    const encoded = query.toString();
    const params = encoded ? `?${encoded}` : '';
    const response = await api.getPublic(
      `/artists/by-slug/${encodeURIComponent(slug)}${params}`,
      config,
    );
    return response.data;
  },

  // 아티스트 상세 조회
  getArtistById: async (artistSource, sourceId, config = {}) => {
    const response = await api.getPublic(
      `/artists?id=${encodeURIComponent(sourceId)}&type=${encodeURIComponent(artistSource?.toLowerCase() || 'apple_music')}`,
      config,
    );
    return response.data;
  },

  getAlbumsByType: async (artistSource, sourceId, albumType) => {
    const response = await api.getPublic(
      `/artists/${albumType}?id=${encodeURIComponent(sourceId)}&type=${encodeURIComponent(artistSource?.toLowerCase() || 'apple_music')}`,
    );
    return response.data;
  },

  getArtistViewByType: async (artistSource, sourceId, viewType, config = {}) => {
    const response = await api.getPublic(
      `/artists/view/${viewType}?id=${encodeURIComponent(sourceId)}&type=${encodeURIComponent(artistSource?.toLowerCase() || 'apple_music')}`,
      config,
    );
    return response.data;
  },
};
